import moment from 'moment';

export default {
  team: 'SUPERDAILY@TEAM',
  landing: {
    name: 'SUPERDAILY',
    title: 'Download the app and change your habits',
    download: 'Download the application',
    iosInstallInfo: 'Install the app on your phone. Click the share button and find:',
    iosInstallInfo2: '"To start screen"',
    desktop: {
      title: 'Develop online and offline habits',
      about: "Download the app and change your habits. App available for iOS and Android. Scan the code with your phone's camera.",
    },
  },
  friends: {
    invide: 'Invite to watch:',
    subscribe: 'Watch a Friend',
    code: 'Your code',
    remove: 'Are you sure you want to stop watching a friend?',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  points: {
    yourPoints: 'Your points:',
  },
  calendar: {
    close: 'Close',
  },
  habits: {
    noHabit: 'You had no habits that day',
  },
  habit: {
    edit: 'Edit',
    webhookTitle: 'QR code for check the habit',
    changeHour: 'Change time',
    showCalendar: 'Show Calendar',
    remove: 'Remove the habit',
    removeDialogTitle: 'Removing a habit',
    noHabits: "you don't have any active habits",
    removeDialogText: 'Are you sure you want to remove the habit?',
    removeDialogConfirm: 'Remove',
    removeDialogCancel: 'Exit',
    changeTimeDialogMessage: 'Change time',
    changeTimeDialogInfo: 'You changed the time to:',
    webhook: 'Once you follow this link, the activity will be credited.'
        + 'You can save the link on an NFC sticker or print a QR code'
        + 'and then after scanning with your phone, score the activity.',
    addNew: 'Add a new habit',
    pickTimeLabel: 'Select the time (affects the order of items in the list)',
    clickToSelect: 'Click to select...',
    addHabit: 'Add a habit',
    closeModal: 'Close',
    IsAlreadyExist: 'such a habit is already active',
  },
  itemModal: {
    title: 'Developing the offline habit',
    addNewPassword: 'Add new password',
    removePassword: 'Delete password',
    password: 'Password',
    save: 'Save',
    exit: 'Exit',
    downloadQRCode: 'Download QR Code',
    saveToNFCTag: 'Save to NFC tag',
    writeToNFCTagMessage: 'Bring your phone to the NFC tag',
    saveNFCSucces: 'Successfully saved the code to NFC!',
    yourPhoneDontSupportNFC: 'Your phone does not currently support NFC saving from this app.',
  },
  account: {
    brandName: 'SuperDaily',
    loginIn: 'Log in',
    googleSignIn: 'Sign in with google',
    githubLogin: 'Login With Github',
    youAreAnonim: 'Jesteś anonimowy',
    logout: 'Log out',
    anonimLoginModalTitle: 'Log in later',
    anonimLoginModalMessage: 'Your data is not assigned to any e-mail account. All your data may be lost. If you want your data to be preserved, please use another login method.',
    anonimLoginModalConfirm: 'Log in',
    anonimLoginModalCancel: 'Cancel',
    youAreOffline: "You're offline. We're working on it.",
  },
  trial: {
    welcomeInBrand: 'Welcome to SuperDaily!',
    setNick: 'First, give a nickname for your account.',
    setingNick: 'Assigning a nickname',
    toLongNick: 'too long, 20 characters max.',
    toShortNick: 'too short, needs to be longer than 5.',
    onlyLettersAndNumbers: 'only normal characters and digits',
    hello: 'Hi',
    wellcomeMessage: 'Nice to meet you. I am Wojtek. I am the creator of SuperDaily. ;)',
    yourFirstTime: 'This is your first time with the app, so I can help you maximize the results you can get from using it.',
    canItakeYouMinutes: 'It will take us max. Two minutes. Can I talk to you for a minute?',
    letsStart: 'Start',
    skipTrial: 'Skip entry',
    afterSkipTrialMessage: "OK, I'll move you to the application",
    thirdStep1: 'To be a master of habits you must first start with something simple.',
    thirsStep2: 'My first habit looked like this:',
    thirdStep3: '"When I finish brushing my teeth in the morning, I will do 1 min of exercise"',
    thirsStep4: 'Note that I specify in what situation the habit is activated.',
    thirdStep5: 'Combining habits that already exist with new ones is a very powerful lifehack',
    thirsStep6: "As soon as I start brushing my teeth in the morning, I remember to exercise. That's how our brains work!",
    thirdStep7: "Now it's time for you. Define your first habit.",
    thirdStep8: 'Define your first habit',
    weAddYourHabit: "We've added your habit, I'll move you to the app soon. Good luck! :)",
  },
  QR: {
    downloadQR: 'Download QR Code',
    back: 'Return',
  },
  succesPage: {
    successMessage: 'Great success!!!',
    backToApp: 'Back to application',
    typePassword: 'Enter your password:',
  },
  menu: {
    settings: 'Settings',
    habits: 'Habits',
    feedback: 'Leave feedback',
    discord: 'Discord',
    news: 'News',
  },
  months: moment.monthsShort(),
  supportUs: 'Support us',
  habitName: 'Name of habit',
  linkToActivity: 'Link to activity',
  toShortLink: 'The link is too short',
  notificationCloseButton: 'Approve',
  habitModalAlertHeader: 'A new habit has been created',
  habitModalAlertContent: 'You can now print the qr code for this habit, so you can score it without going into the app. Simply scan the qr code',
  gamefyRandomize: 'Draw a prize',
  gamefyAddNewReward: 'Add new reward',
};
